export class Orientation {
  public id: number;
  public caption: string;
  public uid: number;

  constructor(id: number, caption: string, uid: number) {
    this.id = id;
    this.caption = caption;
    this.uid = uid;
  }
}
